// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__8Mv0x","crumb":"Breadcrumbs_crumb__3psdp","disabled":"Breadcrumbs_disabled__MFycy"};